import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL, apiUrl } from '../config/api';

// Componentă Operatori – actualizat pentru ca Admin să poată edita/șterge orice înregistrare
const Operatori = ({ operatori, setOperatori, currentUser, currentUserRole, onViewConcedii }) => {
  // Formatter pentru numere cu separator mii conform locale ro-RO (ex: 12.345)
  const numberFormatter = new Intl.NumberFormat('ro-RO');
  // Presupunem o zi standard de lucru de 8 ore pentru calcul productivitate proporțională.
  // Dacă există dataStart & dataTerminare pentru un plan, normalizăm norma la intervalul efectiv lucrat:
  // expected = (nrBuc / SHIFT_HOURS) * durataOre (cu durată limitată la SHIFT_HOURS pentru a evita valori aberante > 1 zi).
  const SHIFT_HOURS = 8; // TODO: poate fi scos în configurare globală sau derivat din stația de lucru.
  const calcExpectedForInterval = (norm, startStr, endStr) => {
    if (!(norm > 0) || !startStr || !endStr) return norm; // fallback fără timp.
    const start = new Date(startStr);
    const end = new Date(endStr);
    if (isNaN(start.getTime()) || isNaN(end.getTime())) return norm;
    const ms = end - start;
    if (!(ms > 0)) return norm;
    let hours = ms / (1000 * 60 * 60);
    // Limităm la o zi standard (dacă s-a uitat închidere sau a trecut peste miezul nopții fără corecție):
    if (hours > SHIFT_HOURS * 1.5) hours = SHIFT_HOURS; // heuristica simplă.
    if (hours <= 0) return norm;
    return (norm / SHIFT_HOURS) * hours;
  };
  const [showModal, setShowModal] = useState(false);
  const [editingOperator, setEditingOperator] = useState(null);
  const [employeeName, setEmployeeName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [importing, setImporting] = useState(false);
  // Norme state
  const [showNormeModal, setShowNormeModal] = useState(false);
  const [normeOperator, setNormeOperator] = useState(null);
  const [normeRows, setNormeRows] = useState([]); // {data, produs, nrBuc}
  const [normeLoading, setNormeLoading] = useState(false);
  const [normeAllRows, setNormeAllRows] = useState([]); // stochează toate liniile brute pt filtrare
  const [normeMonths, setNormeMonths] = useState([]); // luni disponibile
  const [normeSelectedMonth, setNormeSelectedMonth] = useState('ALL');
  // Productivitate state
  const [showProductivitateModal, setShowProductivitateModal] = useState(false);
  const [productivitateOperator, setProductivitateOperator] = useState(null);
  const [productivitateRows, setProductivitateRows] = useState([]); // {denumire, procent}
  const [productivitateLoading, setProductivitateLoading] = useState(false);
  const [productivitateAllPlans, setProductivitateAllPlans] = useState([]); // planurile operatorului pt refiltrare
  const [productivitateMonths, setProductivitateMonths] = useState([]);
  const [productivitateSelectedMonth, setProductivitateSelectedMonth] = useState('ALL');
  // Clasament Productivitate Generala
  const [showClasamentModal, setShowClasamentModal] = useState(false);
  const [clasamentLoading, setClasamentLoading] = useState(false);
  const [clasamentRows, setClasamentRows] = useState([]); // {operator, procent}
  const [clasamentProduse, setClasamentProduse] = useState([]); // lista produse
  const [clasamentSelectedProdus, setClasamentSelectedProdus] = useState('ALL');
  const [clasamentDataCache, setClasamentDataCache] = useState(null); // cache fetch
  const [clasamentMonths, setClasamentMonths] = useState([]); // luni disponibile (YYYY-MM)
  const [clasamentSelectedMonth, setClasamentSelectedMonth] = useState('ALL');
  // Roluri
  // Tratăm atât 'Admin' cât și 'Administrator' ca rol de administrator
  const isAdmin = currentUserRole === 'Admin' || currentUserRole === 'Administrator';
  // Operator role helper
  const isOperator = currentUserRole === 'Operatori' || currentUserRole === 'Operator';

  // Filter states
  const [filters, setFilters] = useState({
    nume: ''
  });

  // Sort states
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'default'
  });

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [inputValue, setInputValue] = useState('25');

  useEffect(() => {
    fetchOperatori();
  }, []);

  const fetchOperatori = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/operatori`);
      setOperatori(response.data);
    } catch (error) {
      console.error('Error fetching operatori:', error);
      setError('Eroare la încărcarea operatorilor');
    }
  };

  // CSV Import/Export Functions
  const handleCSVImport = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setImporting(true);
    setError('');

    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const csv = e.target.result;
        const lines = csv.split('\n').filter(line => line.trim());
        
        if (lines.length < 2) {
          throw new Error('Fișierul CSV trebuie să conțină cel puțin o linie de header și o linie de date');
        }

        const headers = lines[0].split(',').map(h => h.trim().toLowerCase());
        
        if (!headers.includes('nume')) {
          throw new Error('Fișierul CSV trebuie să conțină coloana "nume"');
        }

        const newOperatori = [];
        
        for (let i = 1; i < lines.length; i++) {
          const values = lines[i].split(',').map(v => v.trim());
          if (values.length >= headers.length && values[0]) {
            const operatorData = {
              nume: values[headers.indexOf('nume')],
              createdBy: currentUser?.username
            };
            
            try {
              const response = await axios.post(`${API_BASE_URL}/operatori`, operatorData);
              newOperatori.push(response.data);
            } catch (apiError) {
              console.error(`Error adding operator ${operatorData.nume}:`, apiError);
            }
          }
        }

        setOperatori([...operatori, ...newOperatori]);
        setError(`Import realizat cu succes! Au fost adăugați ${newOperatori.length} operatori.`);

      } catch (error) {
        console.error('CSV import error:', error);
        setError(error.message || 'Eroare la importarea fișierului CSV');
      } finally {
        setImporting(false);
        event.target.value = '';
      }
    };

    reader.onerror = () => {
      setError('Eroare la citirea fișierului');
      setImporting(false);
      event.target.value = '';
    };

    reader.readAsText(file);
  };

  const triggerFileInput = () => {
    document.getElementById('csv-file-input-operatori').click();
  };

  const exportToCSV = () => {
    const filteredData = getFilteredAndSortedOperatori();
    
    if (filteredData.length === 0) {
      setError('Nu există date pentru export');
      return;
    }

    const headers = ['nume', 'createdBy'];
    const csvContent = [
      headers.join(','),
      ...filteredData.map(operator => 
        headers.map(header => operator[header] || '').join(',')
      )
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `operatori_${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setError('Export realizat cu succes!');
    }
  };

  // Filter function
  const handleFilterChange = (column, value) => {
    setFilters(prev => ({
      ...prev,
      [column]: value
    }));
    setCurrentPage(1); // Reset to first page when filtering
  };

  // Sort function
  const handleSort = (column) => {
    setSortConfig(prevConfig => {
      const direction = prevConfig.key === column && prevConfig.direction === 'asc' 
        ? 'desc' 
        : prevConfig.key === column && prevConfig.direction === 'desc'
          ? 'default'
          : 'asc';
      
      return { key: column, direction };
    });
  };

  const getSortIcon = (column) => {
    if (sortConfig.key !== column) return '↕️';
    if (sortConfig.direction === 'asc') return '🔼';
    if (sortConfig.direction === 'desc') return '🔽';
    return '↕️';
  };

  // Filter and sort functions
  const getFilteredAndSortedOperatori = () => {
    let filtered = operatori.filter(operator => {
      return operator.nume.toLowerCase().includes(filters.nume.toLowerCase());
    });

    if (sortConfig.key && sortConfig.direction !== 'default') {
      filtered.sort((a, b) => {
        const aValue = a[sortConfig.key];
        const bValue = b[sortConfig.key];
        
        if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
    }

    return filtered;
  };

  // Pagination functions
  const getTotalPages = () => {
    return Math.ceil(getFilteredAndSortedOperatori().length / itemsPerPage);
  };

  const getPaginatedOperatori = () => {
    const filtered = getFilteredAndSortedOperatori();
    const startIndex = (currentPage - 1) * itemsPerPage;
    return filtered.slice(startIndex, startIndex + itemsPerPage);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= getTotalPages()) {
      setCurrentPage(newPage);
    }
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setInputValue(newItemsPerPage.toString());
    setCurrentPage(1);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    
    const numValue = parseInt(value);
    if (!isNaN(numValue) && numValue >= 1 && numValue <= 1000) {
      setItemsPerPage(numValue);
      setCurrentPage(1);
    }
  };

  const handleAddEmployee = () => {
    setEditingOperator(null);
    setEmployeeName('');
    setShowModal(true);
    setError('');
  };

  const handleEditEmployee = (operator) => {
    if (isOperator) { setError('Operatorii nu pot edita operatori'); return; }
    setEditingOperator(operator);
    setEmployeeName(operator.nume);
    setShowModal(true);
    setError('');
  };

  const handleDeleteEmployee = async (operator) => {
    if (isOperator) { setError('Operatorii nu pot șterge operatori'); return; }
    if (window.confirm(`Sigur doriți să ștergeți operatorul "${operator.nume}"?`)) {
      try {
        setLoading(true);
        await axios.delete(`${API_BASE_URL}/operatori/${operator.id}`, {
          data: { currentUser: currentUser?.username }
        });
        setOperatori(operatori.filter(op => op.id !== operator.id));
        setError('');
      } catch (error) {
        console.error('Error deleting operator:', error);
        setError(error.response?.data?.error || 'Eroare la ștergerea operatorului');
      } finally {
        setLoading(false);
      }
    }
  };

  const handleSave = async () => {
    if (!employeeName.trim()) {
      setError('Numele operatorului este obligatoriu');
      return;
    }

    try {
      setLoading(true);
      setError('');

      if (editingOperator) {
        // Edit existing operator
        const response = await axios.put(`${API_BASE_URL}/operatori/${editingOperator.id}`, {
          nume: employeeName.trim(),
          currentUser: currentUser?.username
        });
        
        setOperatori(operatori.map(op => 
          op.id === editingOperator.id ? response.data : op
        ));
      } else {
        // Add new operator
        const response = await axios.post(`${API_BASE_URL}/operatori`, {
          nume: employeeName.trim(),
          createdBy: currentUser?.username
        });
        
        setOperatori([...operatori, response.data]);
      }

      setShowModal(false);
      setEmployeeName('');
      setEditingOperator(null);
    } catch (error) {
      console.error('Error saving operator:', error);
      setError(error.response?.data?.error || 'Eroare la salvarea operatorului');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setShowModal(false);
    setEmployeeName('');
    setEditingOperator(null);
    setError('');
  };

  const canUserEdit = () => {
    return !isOperator;
  };

  // Deschide modalul Norme și încarcă datele producției pentru operator
  const handleOpenNorme = async (operator) => {
    setNormeOperator(operator);
    setShowNormeModal(true);
    setNormeRows([]);
    setNormeAllRows([]);
    setNormeMonths([]);
    setNormeSelectedMonth('ALL');
    setNormeLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/planificare-productie`);
      const all = Array.isArray(res.data) ? res.data : [];
      const filtered = all.filter(r => Number(r.operatorId) === Number(operator.id));
      const rows = filtered.map(r => ({
        data: r.dataIntrare || '',
        produs: r.produs || '',
        nrBuc: r.nrBuc != null ? r.nrBuc : ''
      }));
      rows.sort((a,b) => a.data < b.data ? 1 : a.data > b.data ? -1 : 0);
      setNormeAllRows(rows);
      // Derivăm lunile
      const monthSet = new Set();
      rows.forEach(r => { if (r.data && /^\d{4}-\d{2}/.test(r.data)) monthSet.add(r.data.substring(0,7)); });
      const months = Array.from(monthSet).sort().reverse();
      setNormeMonths(months);
      setNormeRows(rows); // implicit toate
    } catch (e) {
      console.error('Eroare încărcare norme:', e);
      setError('Eroare la încărcarea normelor');
    } finally {
      setNormeLoading(false);
    }
  };

  // Deschide modal Productivitate
  const handleOpenProductivitate = async (operator) => {
    setProductivitateOperator(operator);
    setShowProductivitateModal(true);
    setProductivitateRows([]);
    setProductivitateAllPlans([]);
    setProductivitateMonths([]);
    setProductivitateSelectedMonth('ALL');
    setProductivitateLoading(true);
    try {
      const [prodResp, planResp] = await Promise.all([
        axios.get(`${API_BASE_URL}/produse`),
        axios.get(`${API_BASE_URL}/planificare-productie`)
      ]);
      const produse = Array.isArray(prodResp.data) ? prodResp.data : [];
      const plans = Array.isArray(planResp.data) ? planResp.data : [];
      const operatorPlans = plans.filter(p => Number(p.operatorId) === Number(operator.id));
      setProductivitateAllPlans(operatorPlans); // stocăm pentru filtrare ulterioară
      // Lunile disponibile
      const monthSet = new Set();
      operatorPlans.forEach(pl => { if (pl.dataIntrare && /^\d{4}-\d{2}/.test(pl.dataIntrare)) monthSet.add(pl.dataIntrare.substring(0,7)); });
      const months = Array.from(monthSet).sort().reverse();
      setProductivitateMonths(months);
      // calcul inițial fără filtru lună
      const rows = computeProductivitateRows(operatorPlans, produse, 'ALL');
      setProductivitateRows(rows);
    } catch(e) {
      console.error('Eroare încărcare productivitate:', e);
      setError('Eroare la încărcarea productivității');
    } finally {
      setProductivitateLoading(false);
    }
  };

  // Deschide clasament productivitate generală (cu filtru lună)
  const handleOpenClasament = async () => {
    setShowClasamentModal(true);
    setClasamentLoading(true);
    setClasamentRows([]);
    setClasamentSelectedProdus('ALL');
    setClasamentSelectedMonth('ALL');
    try {
      const [prodResp, planResp] = await Promise.all([
        axios.get(`${API_BASE_URL}/produse`),
        axios.get(`${API_BASE_URL}/planificare-productie`)
      ]);
      const produse = Array.isArray(prodResp.data) ? prodResp.data : [];
      const plans = Array.isArray(planResp.data) ? planResp.data : [];
      setClasamentProduse(produse);
      setClasamentDataCache({ produse, plans });
      const monthSet = new Set();
      plans.forEach(p => {
        if (p.dataIntrare) {
          const m = p.dataIntrare.substring(0,7);
          if (/^\d{4}-\d{2}$/.test(m)) monthSet.add(m);
        }
      });
      const months = Array.from(monthSet).sort().reverse();
      setClasamentMonths(months);
      setClasamentRows(computeClasamentRows('ALL', 'ALL', plans));
    } catch(e) {
      console.error('Eroare încărcare clasament:', e);
      setError('Eroare la încărcarea clasamentului');
    } finally {
      setClasamentLoading(false);
    }
  };

  const computeClasamentRows = (produsId, monthFilter, plans) => {
    return operatori.map(op => {
      const relevant = plans.filter(p => {
        if (Number(p.operatorId) !== Number(op.id)) return false;
        if (produsId !== 'ALL' && Number(p.produsId) !== Number(produsId)) return false;
        if (monthFilter !== 'ALL') {
            if (!p.dataIntrare || !p.dataIntrare.startsWith(monthFilter)) return false;
        }
        return true;
      });
      let producedSum = 0; let expectedSum = 0;
      relevant.forEach(r => {
        const norm = Number(r.nrBuc);
        if (!(norm > 0)) return;
        if (r.ramase == null || isNaN(Number(r.ramase))) return; // fără date efective
        const produced = Math.min(norm, Math.max(0, norm - Number(r.ramase)));
        const expected = calcExpectedForInterval(norm, r.dataStart, r.dataTerminare);
        producedSum += produced;
        expectedSum += expected;
      });
      let procent = '-';
      if (expectedSum > 0) procent = (producedSum / expectedSum) * 100;
      return { operator: op.nume, procent };
    }).sort((a,b) => {
      if (a.procent === '-' && b.procent === '-') return a.operator.localeCompare(b.operator);
      if (a.procent === '-') return 1;
      if (b.procent === '-') return -1;
      return b.procent - a.procent;
    });
  };

  // Helper pentru recalcul productivitate pe produse (per operator) cu filtru lună
  const computeProductivitateRows = (plans, produse, monthFilter) => {
    const filteredPlans = monthFilter === 'ALL' ? plans : plans.filter(p => p.dataIntrare && p.dataIntrare.startsWith(monthFilter));
    const mapStats = new Map();
    filteredPlans.forEach(pl => {
      if (!pl.produsId) return;
      const key = pl.produsId;
      if (!mapStats.has(key)) {
        mapStats.set(key, { denumire: pl.produs || `Produs ${key}`, produced: 0, expected: 0 });
      }
      const rec = mapStats.get(key);
      const norma = Number(pl.nrBuc);
      if (!(norma > 0)) return;
      if (pl.ramase == null || isNaN(Number(pl.ramase))) return; // fără date efective
      const produced = Math.min(norma, Math.max(0, norma - Number(pl.ramase)));
      const expected = calcExpectedForInterval(norma, pl.dataStart, pl.dataTerminare);
      rec.produced += produced;
      rec.expected += expected;
    });
    return produse.map(pr => {
      const stat = mapStats.get(pr.id);
      if (!stat || !(stat.expected > 0) || stat.produced === 0) {
        if (!stat || stat.produced === 0) return { denumire: pr.denumire || pr.name || `Produs ${pr.id}`, procent: '-' };
      }
      const percent = stat.expected > 0 ? (stat.produced / stat.expected) * 100 : 0;
      return { denumire: stat.denumire, procent: percent };
    }).sort((a,b)=> a.denumire.localeCompare(b.denumire));
  };

  const handleChangeNormeMonth = (e) => {
    const val = e.target.value;
    setNormeSelectedMonth(val);
    if (val === 'ALL') { setNormeRows(normeAllRows); return; }
    const filtered = normeAllRows.filter(r => r.data && r.data.startsWith(val));
    setNormeRows(filtered);
  };

  const handleChangeProductivitateMonth = (e) => {
    const val = e.target.value;
    setProductivitateSelectedMonth(val);
    if (!productivitateAllPlans.length) return;
    // Avem nevoie de lista produse -> extragem din rows existente fallback (nu avem listă separată produse stocată). Soluție simplă: refacem fetch produse minimal? folosim productivitateRows pentru nume.
    // Cum avem doar denumirile in productivitateRows, pentru acuratețe facem un fetch rapid produse (cost mic) – alternativ: stocăm produse la open. Simplific: dacă nu există cache produse, le refacem.
    // Pentru a evita complicare, reutilizăm denumirile actuale: percent recalculat doar pentru produse deja cunoscute plus orice nou apare. Fetch produse pentru consistență.
    axios.get(`${API_BASE_URL}/produse`).then(resp => {
      const produse = Array.isArray(resp.data) ? resp.data : [];
      const rows = computeProductivitateRows(productivitateAllPlans, produse, val);
      setProductivitateRows(rows);
    }).catch(()=>{});
  };

  const handleChangeClasamentProdus = (e) => {
    const val = e.target.value;
    setClasamentSelectedProdus(val);
    if (!clasamentDataCache) return;
    setClasamentRows(computeClasamentRows(val, clasamentSelectedMonth, clasamentDataCache.plans));
  };
  const handleChangeClasamentMonth = (e) => {
    const val = e.target.value;
    setClasamentSelectedMonth(val);
    if (!clasamentDataCache) return;
    setClasamentRows(computeClasamentRows(clasamentSelectedProdus, val, clasamentDataCache.plans));
  };

  return (
    <div>
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <h2>👥 Operatori</h2>
          <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            <button 
              className="btn btn-primary"
              onClick={handleAddEmployee}
              disabled={loading}
            >
              ➕ Adaugă Operator
            </button>
            <button
              className="btn btn-warning"
              onClick={handleOpenClasament}
              disabled={loading}
              style={{ display:'flex', alignItems:'center', gap:'0.4rem', fontWeight:600, whiteSpace:'nowrap' }}
            >
              🏆 Productivitate Generală
            </button>
            <input
              id="csv-file-input-operatori"
              type="file"
              accept=".csv"
              onChange={handleCSVImport}
              style={{ display: 'none' }}
            />
            <button 
              className="btn btn-secondary"
              onClick={triggerFileInput}
              disabled={loading || importing}
              style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
            >
              {importing ? '📂 Importă...' : '📂 Importă CSV'}
            </button>
            <button 
              className="btn btn-success"
              onClick={exportToCSV}
              disabled={loading || importing || operatori.length === 0}
              style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
            >
              📤 Exportă CSV
            </button>
          </div>
        </div>

        {error && (
          <div style={{ 
            background: error.includes('succes') ? '#d1e7dd' : '#f8d7da', 
            color: error.includes('succes') ? '#0f5132' : '#721c24', 
            padding: '0.75rem', 
            borderRadius: '4px', 
            marginBottom: '1rem',
            border: error.includes('succes') ? '1px solid #badbcc' : '1px solid #f5c6cb'
          }}>
            {error}
          </div>
        )}

        {/* Filter Section */}
        <div style={{ marginBottom: '1rem' }}>
          <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', marginBottom: '0.5rem' }}>
            <input
              type="text"
              value={filters.nume}
              onChange={(e) => handleFilterChange('nume', e.target.value)}
              placeholder="Nume"
              style={{ 
                flex: 1,
                padding: '0.5rem', 
                borderRadius: '4px', 
                border: '1px solid #ced4da',
                fontSize: '0.9rem'
              }}
            />
            <button 
              className="btn btn-outline"
              onClick={() => handleSort('nume')}
              style={{ 
                padding: '0.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.25rem',
                fontSize: '0.8rem'
              }}
            >
              Nume {getSortIcon('nume')}
            </button>
          </div>

          {filters.nume && (
            <div style={{ 
              background: '#e7f3ff', 
              color: '#0066cc', 
              padding: '0.5rem', 
              borderRadius: '4px', 
              marginBottom: '0.5rem',
              fontSize: '0.9rem',
              border: '1px solid #b3d9ff'
            }}>
              Filtru activ: <strong>"{filters.nume}"</strong> - 
              <span style={{ marginLeft: '0.5rem' }}>
                {getFilteredAndSortedOperatori().length} din {operatori.length} operatori
              </span>
              <button 
                onClick={() => handleFilterChange('nume', '')}
                style={{ 
                  marginLeft: '0.5rem', 
                  background: 'none', 
                  border: 'none', 
                  color: '#0066cc', 
                  cursor: 'pointer', 
                  textDecoration: 'underline' 
                }}
              >
                Șterge filtru
              </button>
            </div>
          )}
        </div>

        <div style={{ overflowX: 'auto' }}>
          <table className="table">
            <thead>
              <tr>
                <th>Nume Operator</th>
                <th>Creat de</th>
                <th>Acțiuni</th>
              </tr>
            </thead>
            <tbody>
              {getPaginatedOperatori().map(operator => (
                <tr key={operator.id}>
                  <td>{operator.nume}</td>
                  <td>{operator.createdBy}</td>
                  <td>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                      <button
                        className={`btn ${canUserEdit(operator) ? 'btn-warning' : 'btn-disabled'}`}
                        onClick={() => handleEditEmployee(operator)}
                        disabled={!canUserEdit(operator) || loading}
                        style={{ 
                          fontSize: '0.8rem', 
                          padding: '0.25rem 0.5rem',
                          opacity: canUserEdit(operator) ? 1 : 0.5,
                          cursor: canUserEdit(operator) ? 'pointer' : 'not-allowed'
                        }}
                      >
                        ✏️ Editează
                      </button>
                      <button
                        className={`btn ${canUserEdit(operator) ? 'btn-danger' : 'btn-disabled'}`}
                        onClick={() => handleDeleteEmployee(operator)}
                        disabled={!canUserEdit(operator) || loading}
                        style={{ 
                          fontSize: '0.8rem', 
                          padding: '0.25rem 0.5rem',
                          background: canUserEdit(operator) ? '#e74c3c' : '#ccc',
                          opacity: canUserEdit(operator) ? 1 : 0.5,
                          cursor: canUserEdit(operator) ? 'pointer' : 'not-allowed'
                        }}
                      >
                        🗑️ Șterge
                      </button>
                      <button 
                        onClick={() => {
                          // Ensure we're passing a numeric ID
                          const numericId = Number(operator.id);
                          console.log(`Viewing concedii for operator ID: ${numericId} (original: ${operator.id})`);
                          if (isNaN(numericId)) {
                            setError('ID operator invalid');
                            return;
                          }
                          // Extra safety: verify it exists in current list (should always)
                          const exists = operatori.some(op => Number(op.id) === numericId);
                          if (!exists) {
                            setError(`Operatorul cu ID ${numericId} nu există în listă`);
                            return;
                          }
                          onViewConcedii(numericId);
                        }}
                        className="btn btn-info"
                        style={{ 
                          fontSize: '0.8rem', 
                          padding: '0.25rem 0.5rem',
                          backgroundColor: '#17a2b8',
                          color: 'white',
                          textDecoration: 'none',
                          display: 'inline-block',
                          textAlign: 'center'
                        }}
                      >
                        📅 Concedii
                      </button>
                      <button
                        className="btn btn-outline"
                        style={{
                          fontSize: '0.8rem',
                          padding: '0.25rem 0.5rem',
                          border: '1px solid #6c757d',
                          color: '#6c757d',
                          background: 'white'
                        }}
                        onClick={() => handleOpenNorme(operator)}
                        disabled={loading}
                      >
                        📘 Norme
                      </button>
                      <button
                        className="btn btn-outline"
                        style={{
                          fontSize: '0.8rem',
                          padding: '0.25rem 0.5rem',
                          border: '1px solid #6c757d',
                          color: '#6c757d',
                          background: 'white'
                        }}
                        onClick={() => handleOpenProductivitate(operator)}
                        disabled={loading}
                      >
                        📊 Productivitate
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {getFilteredAndSortedOperatori().length === 0 && operatori.length > 0 && (
          <p style={{ textAlign: 'center', color: '#666', margin: '2rem 0' }}>
            Nu s-au găsit operatori care să corespundă filtrelor aplicate.
          </p>
        )}

        {operatori.length === 0 && (
          <p style={{ textAlign: 'center', color: '#666', margin: '2rem 0' }}>
            Nu există operatori adăugați. Folosiți butonul "Adaugă Operator" sau funcția "Importă CSV" pentru a adăuga operatori.
          </p>
        )}

        {/* Pagination */}
        {getFilteredAndSortedOperatori().length > 0 && (
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            marginTop: '1rem', 
            padding: '1rem 0',
            borderTop: '1px solid #dee2e6'
          }}>
            {/* Items per page selector */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
              <span style={{ fontSize: '0.9rem', color: '#666' }}>Operatori per pagină:</span>
              <input
                type="number"
                value={inputValue}
                onChange={handleInputChange}
                min="1"
                max="1000"
                style={{ 
                  width: '70px', 
                  padding: '0.25rem', 
                  borderRadius: '3px', 
                  border: '1px solid #ced4da',
                  textAlign: 'center',
                  fontSize: '0.9rem'
                }}
              />
              <span style={{ fontSize: '0.8rem', color: '#666' }}>(1-1000)</span>
              
              {/* Quick buttons for common values */}
              <div style={{ display: 'flex', gap: '0.25rem' }}>
                {[10, 25, 50, 100].map(value => (
                  <button
                    key={value}
                    onClick={() => handleItemsPerPageChange(value)}
                    style={{
                      padding: '0.2rem 0.4rem',
                      border: '1px solid #ced4da',
                      borderRadius: '3px',
                      fontSize: '0.8rem',
                      backgroundColor: itemsPerPage === value ? '#007bff' : 'white',
                      color: itemsPerPage === value ? 'white' : '#007bff',
                      cursor: 'pointer',
                      minWidth: '25px'
                    }}
                  >
                    {value}
                  </button>
                ))}
              </div>
            </div>

            {/* Pagination controls */}
            {getTotalPages() > 1 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <button
                  onClick={() => handlePageChange(1)}
                  disabled={currentPage === 1}
                  style={{
                    padding: '0.5rem',
                    border: '1px solid #ced4da',
                    borderRadius: '3px',
                    backgroundColor: 'white',
                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                    opacity: currentPage === 1 ? 0.5 : 1
                  }}
                >
                  ⏮️
                </button>
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{
                    padding: '0.5rem',
                    border: '1px solid #ced4da',
                    borderRadius: '3px',
                    backgroundColor: 'white',
                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                    opacity: currentPage === 1 ? 0.5 : 1
                  }}
                >
                  ◀️
                </button>
                <span style={{ fontSize: '0.9rem', padding: '0 0.5rem' }}>
                  {currentPage} din {getTotalPages()}
                </span>
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === getTotalPages()}
                  style={{
                    padding: '0.5rem',
                    border: '1px solid #ced4da',
                    borderRadius: '3px',
                    backgroundColor: 'white',
                    cursor: currentPage === getTotalPages() ? 'not-allowed' : 'pointer',
                    opacity: currentPage === getTotalPages() ? 0.5 : 1
                  }}
                >
                  ▶️
                </button>
                <button
                  onClick={() => handlePageChange(getTotalPages())}
                  disabled={currentPage === getTotalPages()}
                  style={{
                    padding: '0.5rem',
                    border: '1px solid #ced4da',
                    borderRadius: '3px',
                    backgroundColor: 'white',
                    cursor: currentPage === getTotalPages() ? 'not-allowed' : 'pointer',
                    opacity: currentPage === getTotalPages() ? 0.5 : 1
                  }}
                >
                  ⏭️
                </button>
              </div>
            )}

            {/* Page info */}
            <div style={{ fontSize: '0.9rem', color: '#666' }}>
              {getTotalPages() > 1 && `Pagina ${currentPage} din ${getTotalPages()}`}
            </div>
          </div>
        )}
      </div>

  {/* Modal pentru Adăugare/Editare Operator */}
  {showModal && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ 
            padding: '2rem',
            maxWidth: '400px',
            borderRadius: '8px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
          }}>
            <h3 style={{ 
              marginBottom: '1.5rem', 
              color: '#333',
              borderBottom: '2px solid #007bff',
              paddingBottom: '0.5rem'
            }}>
              {editingOperator ? 'Editează Operator' : 'Adaugă Operator Nou'}
            </h3>
            
            <div className="form-group" style={{ marginBottom: '1.5rem' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '0.5rem', 
                fontWeight: '600',
                color: '#555'
              }}>
                Nume Operator *
              </label>
              <input
                type="text"
                value={employeeName}
                onChange={(e) => setEmployeeName(e.target.value)}
                placeholder="Introduceți numele operatorului"
                style={{ 
                  width: '100%',
                  padding: '0.75rem', 
                  borderRadius: '4px', 
                  border: '1px solid #ced4da',
                  fontSize: '1rem',
                  boxSizing: 'border-box'
                }}
                disabled={loading}
              />
            </div>

            {error && (
              <div style={{ 
                background: '#f8d7da', 
                color: '#721c24', 
                padding: '0.5rem', 
                borderRadius: '4px', 
                marginBottom: '1rem',
                fontSize: '0.9rem'
              }}>
                {error}
              </div>
            )}

            <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
              <button 
                className="btn btn-secondary" 
                onClick={handleCancel}
                disabled={loading}
              >
                Anulează
              </button>
              <button 
                className="btn btn-success" 
                onClick={handleSave}
                disabled={loading || !employeeName.trim()}
              >
                {loading ? 'Se salvează...' : 'Salvează'}
              </button>
            </div>
          </div>
        </div>
      )}
      {showNormeModal && (
        <div className="modal-overlay">
          <div className="modal-content" style={{
            padding: '1.5rem 1.5rem 2rem',
            maxWidth: '650px',
            width: '95%',
            borderRadius: '10px',
            boxShadow: '0 6px 28px -8px rgba(0,0,0,0.2),0 4px 12px rgba(0,0,0,0.08)'
          }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1rem' }}>
              <h3 style={{ margin:0, fontSize:'1.15rem', color:'#1f2d3d', borderBottom:'2px solid #1976d2', paddingBottom:'0.4rem' }}>
                Norme – {normeOperator?.nume}
              </h3>
              <button className="close-btn" onClick={()=>{ setShowNormeModal(false); setNormeOperator(null); }} style={{ fontSize:'1.2rem', background:'none', border:'none', cursor:'pointer' }}>×</button>
            </div>
            <div style={{ marginBottom:'0.75rem', display:'flex', alignItems:'center', gap:'0.5rem', flexWrap:'wrap' }}>
              <label style={{ fontSize:'0.85rem', color:'#333' }}>Lună:</label>
              <select value={normeSelectedMonth} onChange={handleChangeNormeMonth} style={{ padding:'0.35rem 0.55rem', fontSize:'0.85rem' }}>
                <option value="ALL">Toate</option>
                {normeMonths.map(m => <option key={m} value={m}>{m}</option>)}
              </select>
            </div>
            {normeLoading && <p>Se încarcă...</p>}
            {!normeLoading && normeRows.length === 0 && (
              <p style={{ margin:'1rem 0', color:'#666' }}>Nu există înregistrări de producție pentru acest operator.</p>
            )}
            {!normeLoading && normeRows.length > 0 && (
              <div style={{ maxHeight:'55vh', overflow:'auto' }}>
                <table className="inner-table" style={{ width:'100%', borderCollapse:'separate', borderSpacing:0 }}>
                  <thead>
                    <tr>
                      <th style={{ position:'sticky', top:0, background:'#f1f5f9' }}>Data</th>
                      <th style={{ position:'sticky', top:0, background:'#f1f5f9' }}>Produs</th>
                      <th style={{ position:'sticky', top:0, background:'#f1f5f9' }}>Nr. Buc</th>
                    </tr>
                  </thead>
                  <tbody>
                    {normeRows.map((r,i)=> (
                      <tr key={i}>
                        <td>{r.data}</td>
                        <td>{r.produs}</td>
                        <td style={{ textAlign:'right', fontWeight:600 }}>
                          {numberFormatter.format(parseInt(r.nrBuc) || 0)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan={2} style={{ textAlign:'right', fontWeight:600 }}>Total</td>
                      <td style={{ textAlign:'right', fontWeight:700 }}>
                        {numberFormatter.format(
                          normeRows.reduce((sum,r)=> sum + (parseInt(r.nrBuc)||0), 0)
                        )}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            )}
            <div style={{ display:'flex', justifyContent:'flex-end', marginTop:'1rem' }}>
              <button className="btn btn-secondary" onClick={()=>{ setShowNormeModal(false); setNormeOperator(null); }}>
                Închide
              </button>
            </div>
          </div>
        </div>
      )}
      {showProductivitateModal && (
        <div className="modal-overlay">
          <div className="modal-content" style={{
            padding: '1.5rem 1.5rem 2rem',
            maxWidth: '550px',
            width: '95%',
            borderRadius: '10px',
            boxShadow: '0 6px 28px -8px rgba(0,0,0,0.2),0 4px 12px rgba(0,0,0,0.08)'
          }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1rem' }}>
              <h3 style={{ margin:0, fontSize:'1.15rem', color:'#1f2d3d', borderBottom:'2px solid #28a745', paddingBottom:'0.4rem' }}>
                Productivitate – {productivitateOperator?.nume}
              </h3>
              <button className="close-btn" onClick={()=>{ setShowProductivitateModal(false); setProductivitateOperator(null); }} style={{ fontSize:'1.2rem', background:'none', border:'none', cursor:'pointer' }}>×</button>
            </div>
            <div style={{ marginBottom:'0.75rem', display:'flex', alignItems:'center', gap:'0.5rem', flexWrap:'wrap' }}>
              <label style={{ fontSize:'0.85rem', color:'#333' }}>Lună:</label>
              <select value={productivitateSelectedMonth} onChange={handleChangeProductivitateMonth} style={{ padding:'0.35rem 0.55rem', fontSize:'0.85rem' }}>
                <option value="ALL">Toate</option>
                {productivitateMonths.map(m => <option key={m} value={m}>{m}</option>)}
              </select>
            </div>
            {productivitateLoading && <p>Se încarcă...</p>}
            {!productivitateLoading && productivitateRows.length === 0 && (
              <p style={{ margin:'1rem 0', color:'#666' }}>Nu există produse în sistem.</p>
            )}
            {!productivitateLoading && productivitateRows.length > 0 && (
              <div style={{ maxHeight:'55vh', overflow:'auto' }}>
                <table className="inner-table" style={{ width:'100%', borderCollapse:'separate', borderSpacing:0 }}>
                  <thead>
                    <tr>
                      <th style={{ position:'sticky', top:0, background:'#f1f5f9' }}>Denumire</th>
                      <th style={{ position:'sticky', top:0, background:'#f1f5f9' }}>Productivitate (%)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productivitateRows.map((r,i)=> (
                      <tr key={i}>
                        <td>{r.denumire}</td>
                        <td style={{ textAlign:'right', fontWeight:600 }}>
                          {r.procent === '-' ? '-' : r.procent.toFixed(1)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <div style={{ display:'flex', justifyContent:'flex-end', marginTop:'1rem' }}>
              <button className="btn btn-secondary" onClick={()=>{ setShowProductivitateModal(false); setProductivitateOperator(null); }}>
                Închide
              </button>
            </div>
          </div>
        </div>
      )}
      {showClasamentModal && (
        <div className="modal-overlay">
          <div className="modal-content" style={{
            padding: '1.5rem 1.5rem 2rem',
            maxWidth: '620px',
            width: '95%',
            borderRadius: '10px',
            boxShadow: '0 6px 28px -8px rgba(0,0,0,0.2),0 4px 12px rgba(0,0,0,0.08)'
          }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1rem' }}>
              <h3 style={{ margin:0, fontSize:'1.15rem', color:'#1f2d3d', borderBottom:'2px solid #ff9800', paddingBottom:'0.4rem' }}>
                Clasament Productivitate
              </h3>
              <button className="close-btn" onClick={()=> setShowClasamentModal(false)} style={{ fontSize:'1.2rem', background:'none', border:'none', cursor:'pointer' }}>×</button>
            </div>
            <div style={{ marginBottom:'0.75rem', display:'flex', gap:'1.25rem', alignItems:'center', flexWrap:'wrap' }}>
              <div style={{ display:'flex', alignItems:'center', gap:'0.4rem' }}>
                <label style={{ fontSize:'0.85rem', color:'#333' }}>Produs:</label>
                <select value={clasamentSelectedProdus} onChange={handleChangeClasamentProdus} style={{ padding:'0.4rem 0.6rem', fontSize:'0.85rem' }}>
                  <option value="ALL">General (toate produsele)</option>
                  {clasamentProduse.map(p => (
                    <option key={p.id} value={p.id}>{p.denumire || p.name || `Produs ${p.id}`}</option>
                  ))}
                </select>
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:'0.4rem' }}>
                <label style={{ fontSize:'0.85rem', color:'#333' }}>Lună:</label>
                <select value={clasamentSelectedMonth} onChange={handleChangeClasamentMonth} style={{ padding:'0.4rem 0.6rem', fontSize:'0.85rem' }}>
                  <option value="ALL">Toate lunile</option>
                  {clasamentMonths.map(m => (
                    <option key={m} value={m}>{m}</option>
                  ))}
                </select>
              </div>
            </div>
            {clasamentLoading && <p>Se încarcă...</p>}
            {!clasamentLoading && (
              <div style={{ maxHeight:'55vh', overflow:'auto' }}>
                <table className="inner-table" style={{ width:'100%', borderCollapse:'separate', borderSpacing:0 }}>
                  <thead>
                    <tr>
                      <th style={{ position:'sticky', top:0, background:'#f1f5f9' }}>Operator</th>
                      <th style={{ position:'sticky', top:0, background:'#f1f5f9' }}>Productivitate (%)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {clasamentRows.map((r,i)=> (
                      <tr key={i}>
                        <td>{r.operator}</td>
                        <td style={{ textAlign:'right', fontWeight:600, color: r.procent==='-' ? '#555' : (r.procent>=100 ? '#1976d2' : '#d32f2f') }}>
                          {r.procent === '-' ? '-' : r.procent.toFixed(1)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <div style={{ display:'flex', justifyContent:'flex-end', marginTop:'1rem' }}>
              <button className="btn btn-secondary" onClick={()=> setShowClasamentModal(false)}>
                Închide
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Operatori;
